import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

import api from '~/services/api';

type Package = {
  id: number;
  professional_id: number;
  gym_id: number;
  name: string;
  lealtad: string;
  status: string;
  value: number;
  number_of_training_programs: number;
  created_at: string;
  updated_at: string;
};

type PackagesData = {
  selectedPackage: Package;
  updateSelectedPackage: (id: number) => void;
  packages: Package[];
  loadPackages: () => Promise<void>;
};

export const PackagesContext = createContext({} as PackagesData);

type PackagesProviderData = {
  children: ReactNode;
};

export function PackagesProvider({ children }: PackagesProviderData) {
  const [selectedPackage, setSelectedPackage] = useState<Package>(
    {} as Package,
  );
  const [packages, setPackages] = useState<Package[]>([]);

  const loadPackages = useCallback(async () => {
    const { data } = await api.get('packages');

    setPackages(data.data);
  }, []);

  function updateSelectedPackage(id: number) {
    const filteredPackage = packages?.filter((package_) => package_.id === id);

    setSelectedPackage(filteredPackage[0]);
  }

  return (
    <PackagesContext.Provider
      value={{ selectedPackage, updateSelectedPackage, packages, loadPackages }}
    >
      {children}
    </PackagesContext.Provider>
  );
}

export const usePackages = (): PackagesData => {
  const context = useContext(PackagesContext);

  if (!context) {
    throw new Error(`usePackages must be use within a PackagesProvider!`);
  }

  return context;
};
